import React from 'react';
import { MdShoppingCart, MdShoppingCartCheckout } from 'react-icons/md';
import { FaPills, FaHospital, FaMoneyBillWave, FaTruck } from 'react-icons/fa';

const PaidAwaitingShippingComponent = () => {
    return (
        <div className="p-4 sm:p-6">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <FaTruck className="text-green-500 text-2xl" />
                    <h2 className="text-xl font-semibold text-gray-800">Order in Transit</h2>
                </div>
                <p className="text-sm text-gray-600">Your order has been paid and is being prepared for shipping</p>
            </div>

            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                        <MdShoppingCartCheckout className="text-green-500 text-3xl" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Order Confirmed</h3>
                    <p className="text-gray-600 max-w-md">
                        Your order has been processed and paid. We'll notify you once it's shipped.
                    </p>
                    <div className="mt-6 flex items-center gap-4 text-sm text-gray-500">
                        <div className="flex items-center gap-2">
                            <FaPills className="text-green-500" />
                            <span>Order Processed</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaMoneyBillWave className="text-green-500" />
                            <span>Payment Received</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaTruck className="text-green-500" />
                            <span>Preparing Shipment</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaidAwaitingShippingComponent;
